import { render, staticRenderFns } from "./view_all.vue?vue&type=template&id=2b569d7d&scoped=true&"
import script from "./view_all.vue?vue&type=script&lang=js&"
export * from "./view_all.vue?vue&type=script&lang=js&"
import style0 from "./view_all.vue?vue&type=style&index=0&id=2b569d7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b569d7d",
  null
  
)

export default component.exports